/**
 * TICK-3252: Move the "Samples" group block (English/Spanish Sample buttons)
 * from the product details column to directly below the product media, so the
 * media + samples form one unit.
 *
 * The Samples block has no unique selector — we find it by walking up from
 * its English/Spanish Sample buttons to the nearest `.group-block` ancestor
 * that contains both buttons.
 *
 * TICK-3921 (change request): the original version ran once at load, so any
 * theme-editor setting change (which re-renders the section) snapped the group
 * back below the description. Now re-applied on `shopify:section:load`.
 * Desktop centering lives in tpi-custom.css under the TICK-3921 banner.
 *
 * TICK-3941 (change request): the client wants the sample buttons below the
 * image on MOBILE as well (Default / Kits templates showed them below the
 * description). The relocation is now viewport-independent — apply once,
 * never undo — so the 3921 breakpoint listener + anchor node are gone.
 * Mobile centering of the relocated group is in tpi-custom.css (TICK-3921 /
 * TICK-3657 rules, now unscoped from the desktop media query).
 */
(function () {
  function sampleButtons() {
    return Array.from(document.querySelectorAll('a, button')).filter((el) => {
      const t = el.textContent.trim().toLowerCase();
      return t === 'english sample' || t === 'spanish sample';
    });
  }

  function findSamplesGroup() {
    const buttons = sampleButtons();
    if (buttons.length === 0) return null;

    let parent = buttons[0].parentElement;
    while (parent && parent !== document.body) {
      if (parent.classList.contains('group-block') && buttons.every((b) => parent.contains(b))) {
        return parent;
      }
      parent = parent.parentElement;
    }
    return null;
  }

  // TICK-3657: tag each sample button's group so CSS can center it.
  function tagSamplesGroups() {
    sampleButtons().forEach((btn) => {
      const group = btn.closest('.group-block');
      if (group) group.classList.add('tpi-samples-group');
    });
  }

  function apply() {
    tagSamplesGroups();

    const mediaContainer = document.querySelector('.product-information__media');
    if (!mediaContainer) return;

    const samples = findSamplesGroup();
    if (!samples || mediaContainer.contains(samples)) return;

    // Hide before moving to avoid a paint with Samples in the old location.
    const previousVisibility = samples.style.visibility;
    samples.style.visibility = 'hidden';
    samples.classList.add('tpi-samples--relocated');
    mediaContainer.appendChild(samples);
    requestAnimationFrame(() => {
      samples.style.visibility = previousVisibility;
    });
  }

  // Defer scripts run after HTML parsing but before DOMContentLoaded — usually
  // before first paint, but not guaranteed. Run immediately if the DOM is ready.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else {
    apply();
  }

  // Theme editor re-renders a section after every setting change, which
  // rebuilds the DOM with the group back in its authored spot. Re-apply so
  // the editor preview keeps matching the live site. No-ops outside the
  // editor (the event never fires there).
  document.addEventListener('shopify:section:load', apply);
})();
